import {atom} from "recoil";

interface IAutoComplete {
    name: string;
    status: boolean;
}

export const autoCompleteAtom = atom<IAutoComplete[]>({
    key: "autoCompleteAtom",
    default: []
});